import React from "react";
import { Layers, Scissors, Flag } from "lucide-react";

const PRODUCTS = [
  {
    icon: Layers,
    eyebrow: "Hot & cold",
    title: "Laminators",
    body:
      "Protect and preserve posters, signage, and classroom visuals so they last the full school year—and beyond.",
    bullets: [
      "Indoor + outdoor durability",
      "Hot & cold options for any media",
      "Protects posters, IDs, lesson aids",
    ],
  },
  {
    icon: Scissors,
    eyebrow: "Decals & lettering",
    title: "Vinyl Cutters",
    body:
      "Create decals, lettering, and custom graphics for walls, signage, and event displays—on demand.",
    bullets: [
      "Custom wall graphics & decals",
      "Cut vinyl letters in any color",
      "School branding made easy",
    ],
  },
  {
    icon: Flag,
    eyebrow: "Display-ready",
    title: "Banner Accessories",
    body:
      "Turn prints into finished banners with professional-grade accessories, kits, and finishing tools.",
    bullets: [
      "Grommets, hems & hanging kits",
      "Pole pockets & banner stands",
      "Ready to hang in minutes",
    ],
  },
];

export default function FinishingProducts() {
  return (
    <section
      id="products-finishing"
      data-testid="finishing-products-section"
      className="bg-white py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-14 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            Product breakdown
          </div>
          <h2
            data-testid="finishing-products-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            The Three Pillars of In-House Finishing
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {PRODUCTS.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`finishing-product-${i}`}
                className="group relative bg-[#F4F6F4] hover:bg-white border border-slate-200 hover:border-teal/40 rounded-2xl p-8 transition-all duration-300 hover:shadow-lg flex flex-col"
              >
                <div className="cmyk-ribbon h-1 w-12 mb-6 rounded-full" aria-hidden />
                <div className="w-14 h-14 rounded-xl bg-navy text-white flex items-center justify-center mb-6 group-hover:bg-teal transition-colors">
                  <Icon className="w-7 h-7" strokeWidth={2} />
                </div>
                <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-teal mb-2">
                  {p.eyebrow}
                </span>
                <h3 className="font-serif text-2xl md:text-3xl font-bold text-navy mb-3 leading-tight">
                  {p.title}
                </h3>
                <p className="text-sm sm:text-base text-slate-600 leading-relaxed mb-6">
                  {p.body}
                </p>
                <ul className="space-y-2 mt-auto pt-4 border-t border-slate-200">
                  {p.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-start gap-2 text-sm text-slate-700"
                    >
                      <span className="flex-shrink-0 mt-1.5 w-1.5 h-1.5 rounded-full bg-teal" />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
